var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function bytesToHuman(bytes) {
  var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
  var KILOBYTE = 1024;
  var MEGABYTE = KILOBYTE * 1024;
  var GIGABYTE = MEGABYTE * 1024;
  var TERABYTE = GIGABYTE * 1024;
  var result = {
    size: bytes,
    unit: "B"
  };
  if (bytes >= KILOBYTE && bytes < MEGABYTE) {
    result.size = bytes / KILOBYTE;
    result.unit = "KB";
  } else if (bytes >= MEGABYTE && bytes < GIGABYTE) {
    result.size = bytes / MEGABYTE;
    result.unit = "MB";
  } else if (bytes >= GIGABYTE && bytes < TERABYTE) {
    result.size = bytes / GIGABYTE;
    result.unit = "GB";
  } else if (bytes >= TERABYTE) {
    result.size = bytes / TERABYTE;
    result.unit = "TB";
  }
  return {
    size: parseFloat("".concat(result.size)).toFixed(precision),
    unit: result.unit
  };
}
__name(bytesToHuman, "bytesToHuman");
export {
  bytesToHuman
};
